<template>
  <md-app md-mode="fixed">
    <md-app-toolbar class="md-toolbar md-primary">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <h3 class="md-title">Messaging</h3>
        </div>
      </div>
      <div class="md-toolbar-row">
        <md-tabs class="md-primary" md-sync-route>
          <md-tab md-label="My Inbox" to="/member/inbox"></md-tab>
        </md-tabs>
      </div>
    </md-app-toolbar>
    <md-app-content>
      <md-tabs id="messaging-tabs" md-sync-route>
        <md-tab id="tab-inbox" to="/member/inbox">
          <InboxView />
        </md-tab>
      </md-tabs>
    </md-app-content>
  </md-app>
</template>
<script>
import InboxView from "@/views/member/inbox/Inbox.vue";
export default {
  name: "MemberDashboard",
  components: {
    InboxView
  },
  data: function() {
    return {};
  },
  methods: {},
  computed: {}
};
</script>
<style>
#messaging-tabs .md-tabs-navigation {
  display: none;
}
</style>
